if (!customElements.get('card-swatch')) {
  customElements.define(
    'card-swatch',
    class CardSwatch extends HTMLElement {
      constructor() {
        super();
        this.labels = this.querySelectorAll('.swatch-input__label');
        this.productImage = this.closest('.product-card-wrapper').querySelector(
          '.card__media img',
        );
        this.swatchWrapper = this.querySelector('ul');
      }

      connectedCallback() {
        this.changeImage();
        this.setSwatchWith();
        this.limitSwatches();

        this._resizeObserver = new ResizeObserver(() => {
          this.setSwatchWith();
          this.limitSwatches();
        });
        this._resizeObserver.observe(this.closest('.product-card-wrapper'));
      }

      changeImage() {
        let image = this.productImage;
        this.labels.forEach((label) => {
          label.addEventListener('click', function () {
            const inputId = this.getAttribute('for');
            const input = document.getElementById(inputId);
            const value = input.value;
            const imageUrl = value.split('?')[0];
            image.src = imageUrl;
            image.srcset = `
              ${imageUrl}?width=165 165w,
              ${imageUrl}?width=360 360w,
              ${imageUrl}?width=533 533w,
              ${imageUrl}?width=720 720w,
              ${imageUrl}?width=940 940w,
              ${imageUrl}?width=1066 1066w,
              ${imageUrl.replace(/&width=\\d+/, '')} 1524w
            `.trim();
          });
        });
      }

      setSwatchWith() {
        const swatchWrapper = this.swatchWrapper;
        const parent = this.closest('.card__content');

        if (parent && swatchWrapper) {
          const updateSwatchWidth = () => {
            swatchWrapper.style.width = `${parent.offsetWidth}px`;
          };

          // Set initial width
          updateSwatchWidth();

          // Create observer
          const resizeObserver = new ResizeObserver(() => {
            updateSwatchWidth();
          });

          // Start observing
          resizeObserver.observe(parent);

          // Optional: store observer if you need to disconnect it later
          this._resizeObserver = resizeObserver;
        }
        this.desktopSwipe();
      }

      desktopSwipe() {
        const slider = this.swatchWrapper;
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
          isDown = true;
          slider.classList.add('active');
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
          isDown = false;
          slider.classList.remove('active');
        });

        slider.addEventListener('mouseup', () => {
          isDown = false;
          slider.classList.remove('active');
        });

        slider.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - startX) * 1;
          slider.scrollLeft = scrollLeft - walk;
        });
      }

      limitSwatches() {
        const wrapper = this.swatchWrapper;
        const items = wrapper.querySelectorAll('.slider__slide');

        // Step 1: Reset state
        items.forEach((item) => {
          item.classList.remove('hidden');
          const existingOverlay = item.querySelector('.more-overlay');
          if (existingOverlay) existingOverlay.remove();
        });

        const wrapperWidth = wrapper.clientWidth;
        let visibleCount = 0;
        let totalWidth = 0;

        // Step 2: Count how many items fit
        items.forEach((item) => {
          const itemStyle = getComputedStyle(item);
          const marginLeft = parseFloat(itemStyle.marginLeft);
          const marginRight = parseFloat(itemStyle.marginRight);
          const fullItemWidth =
            item.getBoundingClientRect().width + marginLeft + marginRight;

          if (totalWidth + fullItemWidth <= wrapperWidth) {
            totalWidth += fullItemWidth;
            visibleCount++;
          }
        });

        const overlayIndex = visibleCount - 1;

        // Step 3: Hide extra items
        items.forEach((item, index) => {
          if (index >= visibleCount) {
            item.classList.add('hidden');
          }
        });

        const hiddenCount = items.length - visibleCount;
        if (hiddenCount > 0 && items[overlayIndex]) {
          const overlayItem = items[overlayIndex];
          const overlay = document.createElement('div');
          overlay.className = 'more-overlay';
          overlay.textContent = `+${hiddenCount}`;

          Object.assign(overlay.style, {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            fontSize: '1rem',
            cursor: 'pointer',
            zIndex: '2',
          });

          overlayItem.style.position = 'relative';
          const label = overlayItem.querySelector('label');
          if (label) {
            label.appendChild(overlay);
          }

          overlay.addEventListener('click', () => {
            items.forEach((item) => item.classList.remove('hidden'));
            overlay.remove();
          });
        }
      }
    },
  );
}
